"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const SelectField = ({ style, name, label, value, children, onChange, idPrefix = 'select-field-', }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuItemClick = (event, selectedValue) => {
        setAnchorEl(null);
        onChange(selectedValue);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            setAnchorEl(null);
        }
    };
    return (<div>
      <Button_1.default style={style} onClick={handleClick} value={value} id={`${idPrefix}-button`}>
        {name}
        {value}
      </Button_1.default>
      <Menu_1.default open={open} anchorEl={anchorEl} aria-label={label} onKeyDown={handleKeyDown}>
        {children.map((key) => {
            var _a;
            return (<MenuItem_1.default key={key.value} id={`${idPrefix}-${(_a = key.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`} selected={key.value === value} onClick={(event) => handleMenuItemClick(event, key.value)}>
            {key.name}
          </MenuItem_1.default>);
        })}
      </Menu_1.default>
    </div>);
};
exports.default = SelectField;
